import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Header from '../../components/header';
import HeaderTitle from '../../components/header-title';
import { getCategories } from '../../selectors/categories-selectors';

const CategoryPageHeader = ({ categories, menu }) => {
  if (categories.length) {
    return categories.length === 1 ? <Header/> : <Header left={<HeaderTitle to={'/'}/>} menu={menu}/>;
  }
};

CategoryPageHeader.propTypes = {
  categories: PropTypes.array,
  menu: PropTypes.node,
};

const mapStateToProps = state => ({
  categories: getCategories(state),
});

export default connect(mapStateToProps)(CategoryPageHeader);



// WEBPACK FOOTER //
// ./app/containers/category-page-header/category-page-header.js